export enum FilterCenterBy {
    RecipientCenter = 1,
    DonorCenter = 2
}